let load = require('./helpers/browser/esm-js-loader');
module.exports = Promise.all([load("ffQaD"), load("kvRbA"), load("dn0w6")]).then(() => parcelRequire('6ItgB'));